











import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IClient } from "@/models/clients";

@Component
export default class AdminClientTransactionsView extends Vue {
  // Props
  @Prop({ required: true })
  public client!: IClient;

  @Prop({ default: () => () => [] })
  public routes!: () => any;

  // Lifecycle methods
  public mounted() {
    this.$bus.$emit("scrollToTop");
  }
}
